export const NAME = "resetPassword"
export const FORM_NAME = `${NAME}_RESET_FORM`
